import { Box, CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  List as BaseList,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  SingleFieldList,
  ChipField,
  ReferenceArrayField,
  TopToolbar,
  CreateButton,
  usePermissions,
  useListContext,
  useGetOne,
  FunctionField,
} from "react-admin";
import useExport from "../components/UseExcelExport";
import ExportButton from "../components/ExcelExportButton";
import moment from "moment";
import UpgradePlanModal from "../components/UpgradePlanModal";
import UpgradeStickyBanner from "../utils/UpgradeStickyBanner";

const ListActions = ({ isEnterprise, onUpgradeClick }) => {
  const { getExportData, exportData, loading, setExportData } = useExport("coupon");
  const [openModal, setOpenModal] = useState(false);
  const { filterValues } = useListContext();

  const handleExportClick = async () => {
    if (!exportData.length) {
      setOpenModal(true);
      await getExportData(filterValues);
      setOpenModal(false);
    }
  };

  const handleClearData = () => {
    setExportData([]);
  };
  const { permissions } = usePermissions();

  const columns = [
    { label: "Nombre", source: "name", width: 30 },
    { label: "Código", source: "code", width: 15 },
    {
      label: "Fecha de expiración",
      source: "expirationDate",
      width: 15,
      transform: (val) => moment(val).format("YYYY-MM-DD"),
    },
    { label: "Usos restantes", source: "usesLeft", width: 15 },
    { label: "Usos máximos", source: "maxUses", width: 30 },
    { label: "Descripción", source: "description", width: 75 },
    { label: "Tipo de descuento", source: "discountType", width: 15 },
    { label: "Descuento", source: "discount", width: 10 },
    { label: "Servicios Válidos", source: "validServices", width: 150 },
  ];
  const disabled = isEnterprise;
  return (
    <TopToolbar>
      <Box display="flex" justifyContent="flex-end" gap="16px">
        {permissions !== "admin-sucursal" && (
          <CreateButton disabled={!disabled} onClick={!isEnterprise ? onUpgradeClick : undefined} />
        )}
        <ExportButton
          onClick={!isEnterprise ? onUpgradeClick : handleExportClick}
          data={exportData}
          columns={columns}
          filename="cupones.xlsx"
          loading={loading}
          clearData={handleClearData}
        />
      </Box>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress />
            <Typography variant="body1" style={{ marginTop: 16 }}>
              Cargando datos para exportación...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </TopToolbar>
  );
};

export const List = (props) => {
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const profile = JSON.parse(localStorage.getItem("profile"));

  const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;

  const { data: provider } = useGetOne("providers", { id: providerId });
  const isEnterprise = provider?.plan === "enterprise";
  return (
    <BaseList
      {...props}
      actions={<ListActions isEnterprise={isEnterprise} onUpgradeClick={() => setOpenUpgradeModal(true)} />}
      sort={{ field: "expirationDate", order: "DESC" }}
    >
      {!isEnterprise && (
        <UpgradeStickyBanner
          planActual={provider?.plan}
          planDestino="Enterprise"
          modulo="Cupones"
          onClickUpgrade={() => setOpenUpgradeModal(true)}
        />
      )}
      <Datagrid
        rowClick={!isEnterprise ? false : "edit"}
        bulkActionButtons={false}
        sx={{
          pointerEvents: !isEnterprise ? "none" : "auto",
          opacity: !isEnterprise ? 0.5 : 1,
          "& .RaDatagrid-headerCell": {
            maxWidth: "100px",
            whiteSpace: "normal",
          },
          "& .RaDatagrid-cell": {
            textAlign: "center",
          },
        }}
      >
        <TextField source="name" label="Nombre" />
        <TextField source="code" label="Código" />
        <DateField source="expirationDate" label="Fecha de expiración" />
        <NumberField source="usesLeft" label="Usos restantes" />
        <NumberField source="maxUses" label="Usos máximos" />
        <TextField source="description" label="Descripción" />
        <TextField source="discountType" label="Tipo de descuento" />
        <NumberField source="discount" label="Descuento" />
        {isEnterprise ? (
          <ReferenceArrayField source="validServices" label="Servicios Válidos" reference="service">
            <SingleFieldList>
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>
        ) : (
          <FunctionField
            label="Servicios Válidos"
            render={(record) =>
              Array.isArray(record.validServices) ? record.validServices.map((s) => s.name).join(", ") : ""
            }
          />
        )}
      </Datagrid>
      <UpgradePlanModal
        open={openUpgradeModal}
        onClose={() => setOpenUpgradeModal(false)}
        planActual={provider?.plan}
        planDestino="enterprise"
      />
    </BaseList>
  );
};
